/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.40.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkofajl%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1vck%7Bbackground-color%3Avar(--ds-background-inverse-subtle%2C%2300000029)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0qidpf%7Bpadding-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3tdidpf%7Bpadding-bottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bvv77o%7Bpadding-left%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f3v77o%7Bpadding-right%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._jqf61teg%7Blabel%3Atooltip-shortcut%7D");
import React, { Fragment } from 'react';
import { formatShortcut, type Keymap } from '../../util/keymaps';
const tooltipShortcutStyle = null;
export const ToolTipContentWithKeymap: React.MemoExoticComponent<({
  description,
  shortcutOverride,
  keymap
}: {
  description?: string | React.ReactNode;
  keymap?: Keymap;
  shortcutOverride?: string;
}) => JSX.Element | null> = React.memo(({
  description,
  shortcutOverride,
  keymap
}: {
  description?: string | React.ReactNode;
  keymap?: Keymap;
  shortcutOverride?: string;
}): JSX.Element | null => {
  const shortcut = shortcutOverride || keymap && formatShortcut(keymap);
  return shortcut || description ? <Fragment>
				{description}
				{shortcut && description && '\u00A0'}
				{shortcut && <span className={ax(["_2rkofajl _bfhk1vck _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"])}>{shortcut}</span>}
			</Fragment> : null;
});